import gql from 'graphql-tag'

export const MAIN_MENU_QUERY = gql`
query {
  menusMenus(filters: { slug: { contains: "main-menu" } }) {
    data {
      id
      attributes {
        title
        slug
        items {
          data {
            id
            attributes {
              title
              target
              url
            }
          }
        }
      }
    }
  }
}
`;
